import { useGetLoginStatusQuery } from "@/app/GlobalRedux/features/auth/authApi"; // Adjust the path to your API slice

const useAuthStatus = () => {
  const { data: isLoggedIn, isLoading, isError } = useGetLoginStatusQuery(undefined);

  return { isLoggedIn, isLoading, isError };
};

export default useAuthStatus;
